import axios from "axios";
import Vue from "vue";
import md5 from "js-md5";
import { get, merge, isObject, isUndefined, set } from "lodash";
import { store, mutations } from "@/observable/store";
import { getAppClient } from "@/utils/commonUtils.js";
import toast from "@/components/common/toast/index.js";
import { CacheModule } from "@/utils/commonUtils";

Vue.use(toast);

const request = axios.create({
  baseURL: `${window.location.origin}/`,
  withCredentials: true,
  timeout: 10000,
  crossDomain: true,
  headers: {
    "Content-Type": "application/json",
    Platform: "sybao_h5",
    "Cache-Control": "no-cache",
    "Access-Control-Allow-Origin": true,
  },
});

// 添加请求拦截器
request.interceptors.request.use((config) => {
  // 处理headers
  const headers = get(config, "headers", {});
  headers["Sy-Token"] = get(store, "syToken", "0");
  const phone = get(store, "phone");
  headers["Trace"] = phone ? md5(phone) : "";
  headers["App-Version"] = get(store, "version", "");
  headers["Platform"] = getAppClient() == "APP" ? "sybao_app" : "sybao_h5";
  headers["Identifier"] = [
    get(store, "uid", ""),
    get(store, "openid", ""),
  ].join("&");
  config.headers = headers;
  return config;
});

// 添加相应拦截器
request.interceptors.response.use(
  (response) => {
    const catchErrorSelf = get(response, [
      "config",
      "headers",
      "Catch-Error_Self",
    ]);
    console.log(response, "response");
    const status = response.status;
    if (status >= 200 && status < 300) {
      const code = get(response, "data.code");
      /** 只认为1000为成功code */
      if (code === 1000) {
        return {
          success: true,
          data: get(response, "data"),
        };
      }
      if (code === 401) {
        mutations.getUid("0");
        mutations.getsyToken("");
        CacheModule.remove("userInfo");
        return {
          success: true,
          data: null,
        };
      }
    }
    const error = new Error(
      get(
        response,
        "data.msg",
        status === 500 ? "系统异常!" : `请求发生错误，http状态码：${status}!`
      )
    );
    error.response = response;
    error.catchErrorSelf = catchErrorSelf;
    throw error;
  },
  (error) => {
    const catchErrorSelf = get(error, [
      "config",
      "headers",
      "Catch-Error_Self",
    ]);
    const message = get(
      error,
      "response.data.error",
      `请求发生错误，http状态码：${get(error, "response.status", "未捕获")}!`
    );
    const newError = new Error(message);
    set(newError, "response", get(error, "response"));
    newError.catchErrorSelf = catchErrorSelf;
    throw new Error(newError);
  }
);

function formatRequestUrl(urlPattern, params = {}) {
  if (!isObject(params)) {
    throw new Error(
      `The type of params must be an object, now is ${typeof params}`
    );
  }
  return urlPattern.replace(/\:(\w+)/gi, (match, p1) => {
    const paramValue = params[p1];
    if (isUndefined(paramValue)) return match;
    return paramValue;
  });
}

export const createApi = (baseOptions = {}) => (callOptions = {}) => {
  const options = merge({}, baseOptions, callOptions);
  const { url, globalLoading = true, urlParams, ...rest } = options;
  if (!url) return Promise.reject(new Error("必须传入url参数！"));
  let apiUrl = process.env.VUE_APP_JAHOST + url;
  if (isObject(urlParams)) {
    apiUrl = formatRequestUrl(apiUrl, urlParams);
  }
  // 全局Loading
  if (globalLoading) {
    Vue.$loading.show();
  }
  return request({
    url: apiUrl,
    ...rest,
  })
    .catch((error) => {
      if (!error.catchErrorSelf) {
        Vue.$toast(error.message);
        return;
      }
      throw error;
    })
    .finally(() => {
      if (globalLoading) {
        Vue.$loading.hide();
      }
    });
};

export default request;
